module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsview page-news"
  }, [_c('c-head'), _vm._v(" "), _c('div', {
    staticClass: "view-content"
  }, [_c('ul', {
    staticClass: "newsList"
  }, _vm._l((_vm.topics), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.go(item.id)
        }
      }
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("dateFormat")(item.create_at)))])])
  })), _vm._v(" "), _c('dialog', {
    attrs: {
      "show": _vm.show
    }
  }, [_c('header', {
    staticClass: "dialog-header",
    slot: "header"
  }, [_c('h1', {
    staticClass: "dialog-title"
  }, [_vm._v("提示信息")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "body"
  }, [_c('p', [_vm._v("你想在对话框中放什么内容都可以！")]), _vm._v(" "), _c('p', [_vm._v("你可以放一段文字，也可以放一些表单，或者是一些图片。")])]), _vm._v(" "), _c('footer', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "c-btn",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关闭")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-92f45e5a!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/news.vue
// module id = 37
// module chunks = 1